import Loader from "./Loader";

interface MessageProps {
  type?: string;
  title?: string;
  message?: string;
}

export default function Message({
  type = "loading",
  title,
  message,
}: MessageProps) {
  return (
    <div>
      {type === "loading" && <Loader />}
      {title && message && (
        <div className="masker">
          <div className="h-48">
            <div className="bg-white px-4 pt-12 pb-12">
              <div className="sm:flex sm:items-start sm:justify-center">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-medium text-gray-900"
                    id="modal-headline"
                  >
                    {title}
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">{message}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
